module.exports = __webpack_public_path__ + "static/media/frog(4).af09aa19.PNG";